import { render, staticRenderFns } from "./CalculateSalaryProcessLucaUploadBordro.vue?vue&type=template&id=6b0c2bac&"
import script from "./CalculateSalaryProcessLucaUploadBordro.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessLucaUploadBordro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports